/* eslint-disable no-console */
import * as ReactDOM from 'react-dom/client'
import {Provider} from 'react-redux'
import {enableMapSet} from 'immer'
import App from './root/App'
import {BrowserRouter} from 'react-router'
import {FleetScoreOverTimeProvider} from './pages/dashboard-v2/components/fleet-score-over-time/contexts/fleet-score-over-time-provider'
import {TagsComponentProvider} from './pages/dashboard-v2/components/tags-component/contexts/tags-component-provider'
import {IncidentsWidgetProvider} from './pages/dashboard-v2/components/incident-response/contexts/incidents-widget-provider'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {GlobalStyles} from './styles/main.styled'

import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'
import 'tippy.js/themes/light-border.css'
import 'react-loading-skeleton/dist/skeleton.css'
import {THREE_MINUTES} from './utils/time'
import {QueryParamInitializer} from './helpers/query-param-initialiser'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'

// Import that has side effects
import {store} from './store'
import './api'

enableMapSet()

let root: ReactDOM.Root | null = null

console.info('%cMedulla by CyberOwl', 'color: cyan; font-weight: bold;')
console.info(`%cVersion: ${import.meta.env.VITE_MEDULLA_VERSION}`, 'color: yellow;')

const rootElement = document.getElementById('root')

if (!rootElement) {
    throw new Error('Root container not found')
}

const queryClient = new QueryClient({
    // If a query defined its own staleTime, it will override.
    defaultOptions: {
        queries: {
            staleTime: THREE_MINUTES,
            retry: 3,
        },
    },
})

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (!root) {
    root = ReactDOM.createRoot(rootElement)
}

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <FleetScoreOverTimeProvider>
                <TagsComponentProvider>
                    <IncidentsWidgetProvider>
                        <QueryClientProvider client={queryClient}>
                            <QueryParamInitializer />
                            <GlobalStyles />
                            <App />
                            <ReactQueryDevtools initialIsOpen={false} />
                        </QueryClientProvider>
                    </IncidentsWidgetProvider>
                </TagsComponentProvider>
            </FleetScoreOverTimeProvider>
        </BrowserRouter>
    </Provider>,
)
